"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { DropdownCategoryType } from '../shared.mjs';
import { CustomValueCategoryContent } from './Categories/CustomValue.mjs';
import { FormulasCategoryContent } from './Categories/Formulas/index.mjs';
import { DropdownPanelFormulaConfig } from './Categories/Formulas/DropdownPanelFormulaConfig.mjs';
import { LookupCategoryContent } from './Categories/Lookup.mjs';
import { OptionsCategoryContent } from './Categories/Options.mjs';
import { RootCategoryContent } from './Categories/Root.mjs';
import { VariablesCategoryContent } from './Categories/Variables.mjs';

const CATEGORY_COMPONENTS = {
  [DropdownCategoryType.ROOT]: RootCategoryContent,
  [DropdownCategoryType.OPTIONS]: OptionsCategoryContent,
  [DropdownCategoryType.VARIABLE]: VariablesCategoryContent,
  [DropdownCategoryType.FORMULA]: FormulasCategoryContent,
  [DropdownCategoryType.FORMULA_CONFIG]: DropdownPanelFormulaConfig,
  [DropdownCategoryType.CUSTOM]: CustomValueCategoryContent,
  [DropdownCategoryType.SELECT_FROM_UDM_DYNAMICALLY]: LookupCategoryContent,
  [DropdownCategoryType.LOOKUP_OPTIONS]: RootCategoryContent
};

export { CATEGORY_COMPONENTS };
